export const initProductMoreDetails = () => {
    document.body.addEventListener('click', function(event) {
        const moreDetailsElement = event.target.closest('.js-more-details');

        if (moreDetailsElement) {
            const productData = moreDetailsElement.querySelector('.product-data');

            if (productData) {
                productData.classList.toggle('open');
            }
        }
    });
};
